export default {
  path: '/journal',
  component: () => import(
    /* webpackChunkName: "journal" */
    /* webpackPrefetch: true */
    './List'
  ),
};
